import React from "react"
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CustomCarousel from "../carousel/CustomCarousel"
import imagePaths from "../../configuration/imagePaths"
import {useMediaQuery} from 'react-responsive'

const carouselData = [
    {
        headerText: "Sistema de Asistencia (Web)",
        subText: "Sistema de control de asistencia web. En proceso de reconstrucción.",
        image: imagePaths.sistemaDeAsistenciaWeb,
        link: "https://sistemadeasistencia.fly.dev/panel",
    },
//   {
//     headerText: "Sistema de Asistencia (Escritorio)",
//     subText: "Sistema de control de asistencia para Windows.",
//     image: imagePaths.sistemaDeAsistenciaEscritorio,
//     link: null,
//   },
    {
        headerText: "Empleos Inclusivos",
        subText: "Portal enfocado en la busqueda de empleos para personas con discapacidad.",
        image: imagePaths.EmpleosInclusivos,
        link: "https://chile.empleosinclusivos.com",
    },
    {
        headerText: "Fila Virtual (Usuario)",
        subText: "Esta aplicación permite tomar números de atención, para distintas organizaciones, de forma virtual.",
        image: imagePaths.filaVirtualUsuario,
        link: "https://fila-de-espera.fly.dev/tomar-numero?idinstitucion=MYonxyijjOEJPDN3&idsede=03YqOCbBR83HzQHM&idfila=juYgnO8kWdCcNUtn",
    },
    {
        headerText: "Fila Virtual (Agente)",
        subText: "Esta aplicación permite a los agentes de atencion, llamar a los números existentes en su fila. Usuario: 31011167, clave: 123",
        image: imagePaths.filaVirtualAgente,
        link: "https://fila-de-espera.fly.dev/administrar-gestor",
    },
    {
        headerText: "Fila Virtual (Administrador)",
        subText: "Esta aplicación permite crear instituciones y sede para las distintas filas virtuales. Usuario: 165579283, clave: 123",
        image: imagePaths.filaVirtualAdministrador,
        link: "https://fila-de-espera.fly.dev/administrar-sistema",
    },
    {
        headerText: "Lector MRZ",
        subText: "Simple aplicacion como prueba de concepto. Con esta aplicación se pueden tomar una imagen de la sección MRZ de una cedula de indentidad y obtener sus datos.",
        image: imagePaths.lectorMRZ,
        link: "https://pacific-mountain-65068.herokuapp.com/",
    },
//   {
//     headerText: 'Registro de Incidencias',
//     subText: "Esta aplicacion permite registrar eventos con ubicacion por GPS.",
//     image: imagePaths.registroDeIncidencias,
//     link: "https://frozen-shore-63665.herokuapp.com/",
//   },
]

export default function PageProjects() {
    const [currentIndex, setCurrentIndex] = React.useState(0)
    const [nextIndex, setNextIndex] = React.useState(carouselData.length === 1 ? 0 : 1)
    const [previousIndex, setPreviousIndex] = React.useState(carouselData.length - 1)

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    const handleSelect = (selectedIndex, e) => {
        setCurrentIndex(selectedIndex)
      console.log("handleSelect:", selectedIndex)

      if(selectedIndex + 1 > carouselData.length - 1){
        setNextIndex(0)
      }else{
        setNextIndex(selectedIndex + 1)
      }
      if(selectedIndex - 1 < 0){
        setPreviousIndex(carouselData.length - 1)
      }else{
        setPreviousIndex(selectedIndex - 1)
      }
    }

    return (<>
        <Stack 
            direction="column"
            alignItems="center"
            spacing={0}
            sx={{ 
                pb: 5,
                marginX: isTabletOrMobile ? 0.5 : 10
            }}
        >
            <Typography variant="h3" sx={{ mt: 2 }}>
                Mis Proyectos
            </Typography>
            <Box sx={{ display: 'flex', height: 400 }}>   
                {carouselData.length === 0 ?
                    <Box sx={{ mt: 20 }}>
                        <p>No hay proyectos cargados</p>
                    </Box>
                :
                <>
                {isTabletOrMobile ?
                    null
                :
                    <CustomCarousel
                        carouselData={carouselData}
                        index={previousIndex}
                        handleSelect={handleSelect}
                        controls={false}
                        indicators={false}
                        showTexts={false}
                        topOffset={13}
                        bottomOffset={10}
                        carouselSize={isTabletOrMobile ? 150 : 170}
                    />
                }

                    <CustomCarousel
                        carouselData={carouselData}
                        index={currentIndex}
                        handleSelect={handleSelect}
                        carouselSize={isTabletOrMobile ? 250 : 300}
                    />

                {isTabletOrMobile ?
                    null
                :
                    <CustomCarousel
                        carouselData={carouselData}
                        index={nextIndex}
                        handleSelect={handleSelect}
                        controls={false}
                        indicators={false}
                        showTexts={false}
                        topOffset={13}
                        bottomOffset={10}
                        carouselSize={170}
                    />     
                }       
                </>
                }
            </Box>
            <h3>
                <a href={carouselData[currentIndex].link} target="_blank">
                    {carouselData[currentIndex].headerText}
                </a>
            </h3>
            <p>{carouselData[currentIndex].subText}</p>
        </Stack>
    </>)
}